//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'
var moment = require('moment-timezone')

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { ProblemsRequestModel, PlanDeliveryModel } from '../api/api.models'
import { CommonHelper, DataType, ViewColumnType } from '../../helpers/common-helper'
import { Api, LocalDictionaryFactory } from './../api/api.module'
import { EventsNames } from '../../helpers/events-names'
import { i18n } from './i18n/common.i18n'
import { Enums } from '../../models/common/enums'
import { GridOptions } from './grid/grid.controller'
import { GetViewColumnOptions } from '../../models/core/op-view'
import { SourceDateBox } from './select-box-popup/select-box-popup.directive'
import { DetailsOptions } from './../common/details-popup/details-popup.directive'
import { ActionRunController } from './action-run/action-run.controller'
import { TemplateHelper, ConfigHelper, LocalizationHelper } from '../../helpers'
import { SystemService, OpenDetailsOrModuleOptions } from '../../services/system'
import { UserSessionService } from '../../services/user-session'
import { IMRBaseControlDirectiveController } from './base'


export interface ScopeBaseGrid extends ng.IScope {
    mainGridOptions: GridOptions

    showGrid: boolean

    popupId: number

    loadingIndicatorOptions: DevExpress.ui.dxLoadIndicatorOptions

    confirmDelete(): void
    showDetails(e: any): void

    needCreateEdit: boolean
    needConfirmDelete: boolean
    needActionRun: boolean
    datePickerBridge: SourceDateBox

    PLAN_DELIVERY_POPUP_ID: string
    PROBLEM_CHANGE_POPUP_ID: string
    needLocationProblemsChange: boolean
    needPlanDelivery: boolean
}

export class BaseGridController extends IMRBaseControlDirectiveController {

    //#region Consts

    private readonly LOG_PREFIX = '[SIMAX.Common.BaseGridController]'

    //#endregion

    protected preExecuteGridClearFilter: boolean
    protected dataGrid: DevExpress.ui.dxDataGrid
    protected gridId: number
    protected isTouchScreen: boolean = false

    private redirectionOptions: OpenDetailsOrModuleOptions

    constructor(
        protected $scope: ScopeBaseGrid,
        protected $timeout: ng.ITimeoutService,
        protected $state: StateService,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        protected api: Api,
        protected localDictionary: LocalDictionaryFactory,
        protected type: number,
        protected referenceType: Enums.ReferenceType
    ) {
        super()

        $scope.popupId = new Date().getTime()
        $scope.PLAN_DELIVERY_POPUP_ID = new Date().getTime() + 'planDelivery'
        $scope.PROBLEM_CHANGE_POPUP_ID = new Date().getTime() + 'problemChange'

        $scope.loadingIndicatorOptions = {
            width: 40,
            height: 40
        }

        $scope.$on(EventsNames.SERVER_EXCEPTION_OCCURED, () => {
            this.$scope.showGrid = true
        })

        if ($state.params['ids'] && this.$state.params['ids'].length > 0) {
            this.preExecuteGridClearFilter = true
        }

        $scope.$on('moduleChanging', () => {
            $scope.showGrid = false
        })

        $scope.$on('stopModuleChanging', () => {
            $scope.showGrid = true
        })
    }

    protected showDetails(e: any, typeOrOptions: number | DetailsOptions, keyField = CommonHelper.idField, objectIds = this.getPageItemsIds(keyField)) {
        if (typeof typeOrOptions === 'number') {
            this.$scope.$root.$broadcast(EventsNames.OPEN_DETAILS_OR_MODULE, typeOrOptions, objectIds, e.data[keyField])
        } else {
            this.$scope.$root.$broadcast(EventsNames.OPEN_DETAILS_OR_MODULE, typeOrOptions)
        }
    }

    protected setGridId(gridId: number) {
        this.gridId = gridId
    }

    protected getSelectedItemId(): number {
        return this.dataGrid.getSelectedRowsData()[0][CommonHelper.idField]
    }

    protected getPageItemsIds(keyField = CommonHelper.idField): number[] {
        return this.dataGrid.option("dataSource").items().map(item => item[keyField])
    }

    protected getCorrespondingActionType(type: number, event) {
        this.$scope.needActionRun = true

        let selecteRows = this.dataGrid.getSelectedRowsData()

        event.event.stopPropagation()

        ActionRunController
            .openActionPopup(this.$scope, this.$timeout, this.userSession.getDataProvider(), selecteRows, this.referenceType, this.$scope.popupId)
            .fail((error: string) => {
                if (error != null) {
                    CommonHelper.openInfoPopup(error, 'error', 4000)
                }
            })
    }

    protected onDataReady = (data: any[]) => {
        this.$scope.showGrid = true
    }

    protected mergeWithDefaultItems(isTouchScreen: boolean = false, items = []) {
        var selectedRows = this.dataGrid.getSelectedRowsData()

        if (selectedRows.length === 1 && this.$scope.showDetails) {
            items.unshift({
                template:
                    TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDetails), ConfigHelper.Icon.DETAILS, this.userSession),
                onItemClick: () => { this.$scope.showDetails({ data: selectedRows[0] }) }
            })
        }

        return items;
    }

    protected detailsInContextList(isTouchScreen: boolean = false, items = []) {
        if (isTouchScreen) {
            var selectedRows = this.dataGrid.getSelectedRowsData()
            if (selectedRows.length === 1 && this.$scope.showDetails) {
                items.push({
                    template:
                        TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDetails), ConfigHelper.Icon.DETAILS, this.userSession),
                    onItemClick: () => { this.$scope.showDetails({ data: selectedRows[0] }) }
                })
            }
        }
        return items
    }

    protected getItems(isTouchScreen: boolean = false): JQueryPromise<any[]> {
        return $.Deferred().resolve().promise().then(() => {
            return this.detailsInContextList(isTouchScreen)
        })
    }

    protected onAlarmDoneMenuClick() {
        var selectedRows: any[] = this.dataGrid.getSelectedRowsData()
        var ids = selectedRows.map(r => r.id)
        this.api.alarm.confirmAlarms(ids).then(result => {
            if (ids.length == 1) CommonHelper.openInfoPopup(i18n('Common', 'AlarmApproved'))
            else CommonHelper.openInfoPopup(i18n('Common', 'AlarmsApproved'))
            this.$scope.$root.$broadcast(EventsNames.ALARM_APPROVED, ids.length)
        })
    }

    protected showRadioDeviceDetails(e) {
        var itemIds = this.dataGrid.option("dataSource").items().map(item => item['serialNbrParent'])
        this.$scope.$root.$broadcast(EventsNames.OPEN_DETAILS_OR_MODULE, CommonHelper.IdDevice, itemIds, e.data['serialNbrParent'])
    }

    protected addCustomGridFilter(filter: any) {
        var self = this
        filter.clearFilter = () => {
            if (self.dataGrid) {
                var filters: any = self.dataGrid.filter()
                if (filters) {
                    filters = filters.filter(filter => {
                        return !filter.customgridfilter
                    })
                    if (filters.length > 0)
                        self.dataGrid.filter(filter)
                    else
                        self.dataGrid.filter(null)
                }
            }
        }
        filter.customgridfilter = true
        if (this.dataGrid) {
            try {
                this.dataGrid.clearFilter()
                this.dataGrid.filter([filter])
            } catch (e) { }
        }
    }

    //context menu
    //locations
    protected getLocationsProblems(gridId: number = null) {
        this.$scope.needLocationProblemsChange = true
        var isDashboard: boolean = false
        this.$timeout(() => {
            var locations: any[] = this.dataGrid.getSelectedRowsData()
            var idLocations = locations.map(loc => {
                if (loc.referencevaluearray && loc.referencevaluearray.length > 0) { // dashboard
                    isDashboard = true
                    return loc.referencevaluearray[0]
                } else {//main grid
                    return loc.id
                }
            })

            var selectBoxSource = {
                nothingSelectedMsg: '',
                onSubmit: null,
                onSubmitMulty: (ids: any[]) => {
                    this.$scope.$root.$broadcast('showLoadingIndicator')
                    var model: ProblemsRequestModel = {
                        locationIds: idLocations,
                        problemIds: ids
                    }
                    this.api.location.saveProblems(model).then(result => {
                        if (result && !result.errorMessage) {
                            CommonHelper.openInfoPopup(i18n('Popup', 'ErrorsAccepted'))
                            this.$scope.$root.$broadcast('hideLoadingIndicator')
                            if (!isDashboard) this.dataGrid.refresh()
                            else {
                                if (gridId)
                                    this.$scope.$root.$broadcast(EventsNames.UPDATE_DASHBOARD_ITEM_WS, gridId)
                            }
                        } else {
                            CommonHelper.openInfoPopup(i18n('Popup', 'ErrorsAcceptionProblem'), 'error', 5000)
                        }
                    })
                },
                popupTitle: i18n('Popup', 'ExceptionList'),
                needConfirmation: true,
                selectPopoverSource: {
                    myltySelection: true,
                    dictionaryMethod: 'getMeasurementsDataTypesFilterColumns',
                    staticSource: [],
                    selectedIds: [],
                    visible: true,
                    //clearSelection: true
                }
            }

            this.api.location.getProblems(idLocations).then(res => {
                selectBoxSource.selectPopoverSource.staticSource = res.result
                selectBoxSource.selectPopoverSource.selectedIds = res.result.map(r => { return r.id })
                selectBoxSource.popupTitle
                this.$timeout(() => {
                    this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_MULTY_SELECTION_POPUP + this.$scope.PROBLEM_CHANGE_POPUP_ID, selectBoxSource, idLocations)//, statusIds)
                })
            })
        })
    }

    protected planDelivery(gridId: number = null) {
        var locations: any[] = this.dataGrid.getSelectedRowsData()
        var isDashboard: boolean = false
        var idLocations = locations.map(loc => {
            if (loc.referencevaluearray && loc.referencevaluearray.length > 0) { // dashboard 
                isDashboard = true
                return loc.referencevaluearray[0]
            } else {//main grid
                return loc.id
            }
        })
        this.$scope.needPlanDelivery = true
        this.$scope.datePickerBridge = {
            type: 'date',
            value: null,
            minDate: new Date(),
            popupTitle: i18n('Popup', 'SelectDate'),
            needConfirmation: true,
            onSubmit: (value) => {
                this.$scope.needPlanDelivery = false
                this.$scope.$root.$broadcast('showLoadingIndicator')
                var model = new PlanDeliveryModel()
                model.deliveryDate = value
                model.locationIds = idLocations
                if (value) {
                    value = moment(value).toDate()
                    value.setHours(0, 0, 0, 0)
                    value = moment(value)
                    model.deliveryDate = value.add(value.utcOffset(), 'minutes').toDate()
                }
                this.api.location.planDelivery(model).then((result) => {
                    if (result && !result.errorMessage) {
                        CommonHelper.openInfoPopup(i18n('Popup', 'DeliveryPalnned'))
                        if (!isDashboard) this.dataGrid.refresh()
                        else {
                            if (gridId)
                                this.$scope.$root.$broadcast(EventsNames.UPDATE_DASHBOARD_ITEM_WS, gridId)
                        }
                    } else {
                        CommonHelper.openInfoPopup(i18n('Popup', 'ErrorsSavingPlannedDelivery'), 'error', 5000)
                    }
                }).finally(() => {
                    this.$scope.$root.$broadcast('hideLoadingIndicator')
                })
            }
        }

        this.$timeout(() => {
            this.$scope.$broadcast(EventsNames.OPEN_DATEBOX_POPUP + this.$scope.PLAN_DELIVERY_POPUP_ID, this.$scope.datePickerBridge)
        })
    }
    //end locations
    //device connctions
    //TO DO!!! Jałowizna!
    protected onShowHubsDetailsPreview() {
        var columnName = this.getColumnName(DataType.HELPER_SERIAL_NBR, true)
        var filter = [columnName, '=', this.getSerialNbr(this.dataGrid.getSelectedRowsData()[0])]
        this.addCustomGridFilter(filter)
    }
    //TO DO!!! Jałowizna!
    protected onShowRadioDevicesDetailsPreview() {
        var serialNbrParent = this.getSerialNbrParent(this.dataGrid.getSelectedRowsData()[0])
        if (serialNbrParent) {
            var columnName = this.getColumnName(DataType.HELPER_SERIAL_NBR_PARENT)
            var filter = [columnName, '=', serialNbrParent]
            this.addCustomGridFilter(filter)
        } else
            CommonHelper.openInfoPopup(i18n('Common', 'NoHub'), 'info', 5000)
    }
    //TO DO!!! Jałowizna!
    private getColumnName(id: number, isBaseHelper: boolean = false) {
        var activeView = this.localDictionary.getActiveView(CommonHelper.IdDeviceConnection)
        if (activeView) {
            var getViewColumnParameters = new GetViewColumnOptions(id)
            if (isBaseHelper)
                getViewColumnParameters.viewColumnType = ViewColumnType.BaseHelper
            var columnName = activeView.getViewColumn(getViewColumnParameters).name
            return columnName
        }
        return ViewColumnType.BaseHelper.toString()
    }
    //TO DO!!! Jałowizna!
    protected getSerialNbr = (column) => {
        return column.serialNbr
    }
    //TO DO!!! Jałowizna!
    protected getSerialNbrParent = (column) => {
        return column.serialNbrParent
    }
    //end device connctions
    //report
    protected onReposrtGenerate() {
        this.$scope.$broadcast(EventsNames.REPORT_GENERATE, this.dataGrid.getSelectedRowsData()[0]);
    }
    //end report
    //operator
    //PRObLEM WITH BUTTONOPTIONS!!!!
    protected onOperatorCopy() {
        this.$scope['mainGridOptions'].buttonsOptions.copyOperator = true
        this.$scope['mainGridOptions'].buttonsOptions.onEditClick(this.dataGrid.getSelectedRowsData()[0][CommonHelper.idField])
    }
    //end operator
    //task
    protected showTaskStatusPopup() {
        this.$scope['needStatusChange'] = true
        this.$timeout(() => {
            var selectedRows = this.dataGrid.getSelectedRowsData()
            var statusIds = []
            var ids = []

            selectedRows.forEach(row => {
                ids.push(row['id'])
                statusIds.push(row['statusId'])
            })

            this.$scope.$broadcast(EventsNames.OPEN_TASKS_STATUS_CHANGE_POPUP, ids, statusIds)
        })
    }
    //end task    
}
